import React, { useContext } from 'react';
import {
	ApSecondaryNav,
	ApButtonTab,
	colors,
	ApButtonIcon,
	ApTooltip,
} from '@alixpartners/ui-components';
import SearchDialog from '../SearchDialog';
import { NavLink, useLocation } from 'react-router-dom';
import FilterPanel from './FilterPanel';
import { NAV_CONFIG } from '../utils';
import {
	BackButtonWrapper,
	TransactionsTitle,
	ButtonIcon,
} from './SecondaryNav.styles';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export const SecondaryNav = ({
	transactionsTitle,
	onBackButtonClick,
	showExplorePage,
}) => {
	const location = useLocation();
	const history = useHistory();
	const { permissions } = useContext(PermissionsContext);

	const hasSomePermissions = requiredSome => {
		return !requiredSome || requiredSome.some(i => permissions.includes(i));
	};

	const navigateToDemoVideosHandler = () =>
		history.push({
			pathname: '/introduction',
			hash: '#stats',
			state: { openAccordionId: 1 },
		});

	return (
		<ApSecondaryNav
			left={
				transactionsTitle ? (
					<BackButtonWrapper>
						<ButtonIcon
							iconName="baseline_arrow_back"
							iconProps={{ iconColor: colors.grey8 }}
							onClick={onBackButtonClick}
						/>
						<TransactionsTitle>{transactionsTitle}</TransactionsTitle>
					</BackButtonWrapper>
				) : (
					NAV_CONFIG.map(({ label, path, disabled, requiredSome }) => (
						<NavLink
							to={path}
							key={path}
							disabled={disabled || !hasSomePermissions(requiredSome)}
						>
							<ApButtonTab
								isSelected={location.pathname === path}
								disabled={disabled || !hasSomePermissions(requiredSome)}
							>
								{label}
							</ApButtonTab>
						</NavLink>
					))
				)
			}
			right={
				<React.Fragment>
					<FilterPanel />
					<SearchDialog showExplorePage={showExplorePage} />
					<ApTooltip
						placement="left"
						message="Click here to access demo videos."
					>
						<ApButtonIcon
							iconName="video_library"
							iconProps={{ material: true }}
							onClick={navigateToDemoVideosHandler}
						/>
					</ApTooltip>
				</React.Fragment>
			}
		/>
	);
};

export default SecondaryNav;
